import React, { Component } from 'react';
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { toastError, countryActionId, cityActionId, industryActionId, stateActionId, downloadReport, toastSuccess, sessionExpireMessage, tokenInavlidMessage } from '../../../utils/constants'
import { fill_action } from '../../../actions/fillCombo_action'
import Pagination from "../../../utils/pagination";
import Header from '../../../common_components/Header';
import { get_eventMaster_list_action, delete_eventMaster_action } from '../../../actions/adminAction/event_master_action';
import moment from 'moment';
import Loader from '../../../utils/Loader';

class eventMasterList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false, isFilterShow: false,
            EventID: '', currentPage: 1, recordsPerPage: 10, eventMasterList: [], Title: '', isActive: 1,
            FullAccess: false, ReadAccess: false, WriteAccess: false, UpdateAccess: false, DeleteAccess: false, DownloadAccess: false, Is_SpecialAccess: false, SendAccess: false
        }
        this.updateItem = this.updateItem.bind(this);
        this.updateRecordsPerPage = this.updateRecordsPerPage.bind(this);
    }
    componentDidMount() {
        if (JSON.parse(sessionStorage.getItem("loginDataSS")) == null) {
            setTimeout(() => {
                this.props.navigate('/');
            }, 200);
            return;
        }

        window.scrollTo(0, 0);
        const loginAccessList = JSON.parse(sessionStorage.getItem('loginAccesslist')) || [];
        const eventMasterListModule = loginAccessList.find(module => module.ModuleName === "Event Master");

        if (eventMasterListModule) {
            const { FullAccess, ReadAccess, WriteAccess, UpdateAccess, DeleteAccess, DownloadAccess, Is_SpecialAccess, SendAccess } = eventMasterListModule;

            if (!FullAccess && !ReadAccess) {
                this.props.navigate('/login'); // Navigate to login if no access
            } else {
                this.setState({
                    FullAccess: !!FullAccess,
                    ReadAccess: !!ReadAccess,
                    WriteAccess: !!WriteAccess,
                    UpdateAccess: !!UpdateAccess,
                    DeleteAccess: !!DeleteAccess,
                    DownloadAccess: !!DownloadAccess,
                    Is_SpecialAccess: !!Is_SpecialAccess,
                    SendAccess: !!SendAccess
                });

                if (FullAccess) {
                    this.setState({
                        ReadAccess: true,
                        WriteAccess: true,
                        UpdateAccess: true,
                        DeleteAccess: true,
                        DownloadAccess: true,
                        Is_SpecialAccess: true,
                        SendAccess: true
                    });
                }
            }
        } else {
            this.props.navigate('/login');
        }

        if (loginAccessList.length) {
            // this.getFillList(countryActionId, '', '', '', '').then(() => {
            this.getEventMasterList();
        }
        // });
    }


    getFillList(actionID, ModuleID, KeyValue, Value, UserID) {
        this.setState({ isLoading: true })
        return new Promise(() => {
            this.props
                .fill_action(actionID, ModuleID, KeyValue, Value, UserID)
                .then((data) => {
                    if (data.error != 1) {
                        // if (actionID === countryActionId) {
                        //     this.setState({ countryList: data.data })
                        //     resolve(true)
                        // }

                    }
                })
        })
    }

    getEventMasterList() {
        const { Title, isActive } = this.state
        this.setState({ isLoading: true })
        this.props
            .get_eventMaster_list_action(Title, isActive,1)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ eventMasterList: data.data });
                    setTimeout(() => {
                        this.setState({ isLoading: false });
                    }, 500);
                } else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                }
            }).catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }
    clearFilter() {
        this.setState({ Title: '', isActive: 1 }, () => this.getEventMasterList())
    }
    navigateEventEdit(EventID) {
        const { eventMasterList } = this.state;
        const seqNo = eventMasterList.length + 1
        this.props.navigate('/event_master_detail', { state: { EventID: EventID, seqNo: seqNo } })
    }
    updateItem(item) {
        this.setState({ currentPage: item });
    }
    updateRecordsPerPage = (count) => {
        this.setState({ recordsPerPage: count, currentPage: 1 }, () => window.scrollTo(0, 0));
    };
    eventMasterRecord(eventMasterList) {
        const { UpdateAccess, DeleteAccess } = this.state;
        return (
            <table className="table table-bordered table-striped mg-b-0">
                <thead>
                    <tr>
                        <th>Event Name</th>
                        <th>Duration</th>
                        <th>Event Type</th>
                        <th>Status</th>
                        <th className="text-right" style={{ width: "10%" }} />
                    </tr>
                </thead>
                <tbody id="myTable">
                    {eventMasterList.length > 0 ? eventMasterList.map((data) => (
                        <tr>
                            <td>{data.Title}</td>
                            <td>{data.Duration}</td>
                            <td>{data.isMemberDashboard==1?'User Dashboard':'Upcoming Event'}</td>
                            <td>{data.isActive == true ? 'Active' : 'InActive'}</td>
                            <td className="text-center" style={{ width: '5%' }}>
                                {UpdateAccess && <>
                                    <a
                                        onClick={() => this.navigateEventEdit(data.EventID)}
                                        title="Edit Role"
                                        className="load_document_icon mx-2"
                                        data-toggle="modal"
                                        data-target="#add_comment_modal"
                                    >
                                        <i className="fa fa-edit" />
                                    </a>
                                </>}
                                {(DeleteAccess && data.isActive) && <>
                                    <a
                                        onClick={() => this.deleteEventMaster(data.EventID)}
                                        title="Delete Role"
                                        className="load_document_icon mx-2"
                                        data-toggle="modal"
                                        data-target="#add_comment_modal"
                                    >
                                        <i className="fa fa-trash" />
                                    </a>
                                </>}
                            </td>

                        </tr>
                    )) : (
                        <tr>
                            <td colSpan={12}> No Record Found</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }
    toggleFilterCollapse() {
        this.setState((prevstate) => ({
            isFilterShow: !prevstate.isFilterShow
        }))
    }
    deleteEventMaster(EventID) {
        this.setState({ isLoading: true })
        const isConfirm = window.confirm('Are you sure you want to delete this Event?')
        if (isConfirm) {
            this.props
                .delete_eventMaster_action(EventID)
                .then((data) => {
                    if (data.error != 1) {
                        toastSuccess('Event Deleted Successfully')
                        setTimeout(() => {
                            this.setState({ isLoading: false });
                            this.getEventMasterList()
                        }, 500);
                    } else {
                        if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                            //after session expire.....................
                            sessionStorage.clear();
                            this.props.navigate("/");
                            setTimeout(() => {
                                toastError(data.msg);
                            }, 2000);
                        } else {
                            toastError(data.data);
                        }
                        this.setState({ isLoading: false })
                        toastError(data.data.ErrorMsg);
                    }
                }).catch((e) => {
                    console.log(e);
                    this.setState({ isLoading: false });
                });
        } else {
            this.getEventMasterList()
        }
    }
    render() {
        const { isLoading, currentPage, eventMasterList, isFilterShow, Title, recordsPerPage, isActive } = this.state
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        const currentRecords = eventMasterList.slice(
            indexOfFirstRecord,
            indexOfLastRecord
        );
        const nPages = Math.ceil(eventMasterList.length / recordsPerPage);
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                    // <></>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />
                <ToastContainer />
                <section class="registration_form">
                    <div class="container">
                        <div class="row mt-15">
                            <section className="table_section">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12 col-sm-12 col-lg-12">
                                            <div className="card shadow-none border mb-2" >
                                                <div className="card-header py-2">
                                                    <h6 className='pt-2' style={{ float: 'left' }}>Event Master List</h6>
                                                    {(JSON.parse(sessionStorage.getItem('loginDataSS'))?.RoleName == 'Super Admin' || JSON.parse(sessionStorage.getItem('loginDataSS'))?.RoleName == 'Admin') ? <>
                                                        <a style={{ float: 'right' }}
                                                            href="javascript:void(0);"
                                                            className="btn btn-purple custom_btn"
                                                            title="Filter"
                                                            data-toggle="modal"
                                                            data-target="#filter_modal"
                                                            onClick={() => this.toggleFilterCollapse()}
                                                        >
                                                            <i className="fa fa-filter" />
                                                        </a>
                                                        <a style={{ float: 'right' }}
                                                            href="javascript:void(0);"
                                                            title="Add Role"
                                                            onClick={() => this.navigateEventEdit(null)}
                                                            className="load_document_icon  p-1 px-2 send_credentials-btn mx-1"
                                                            data-toggle="modal"
                                                            data-target="#add_comment_modal"
                                                        >
                                                            Add
                                                        </a>

                                                    </> : <></>}
                                                </div>
                                                <ul className="list-group list-group-flush" >
                                                    {isFilterShow && <>

                                                        <li className="list-group-item"><div className="row">
                                                            <div class="col-md-3">
                                                                <div class="form-group">
                                                                    <label>Event Name</label>
                                                                    <input type="text" class="form-control" placeholder="Enter Event Name" value={Title} onChange={(e) => this.setState({ Title: e.target.value })} maxLength={1000} />

                                                                </div>
                                                            </div>
                                                            <div class="col-md-3">
                                                                <div class="form-group">
                                                                    <label>Status</label>
                                                                    <select className="form-control" value={isActive} id="privileges" onChange={(e) => this.setState({ isActive: e.target.value })}>
                                                                        <option value={''}>Select</option>
                                                                        <option value={1}>Active</option>
                                                                        <option value={0}>InActive</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-xl-2 mb-3">
                                                                < button style={{ marginTop: '20px' }} className='btn btn-primary mr-2' onClick={() => this.getEventMasterList()}>
                                                                    Search
                                                                </button>
                                                                <button type="button" style={{ marginTop: '20px' }} className='btn btn-dark mr-2 ms-2' onClick={() => this.clearFilter()}>
                                                                    Clear
                                                                </button>
                                                            </div>
                                                        </div></li>
                                                    </>}
                                                </ul>
                                            </div>

                                            <div className="card shadow-none border">
                                                <div className="card-body p-2 pb-0">

                                                    <div className="custom_table">
                                                        <div className="hack1">
                                                            <div className="hack2">
                                                                {this.eventMasterRecord(currentRecords)}
                                                                {eventMasterList.length > 0 ? (
                                                                    <Pagination
                                                                        nPages={nPages}
                                                                        currentPage={currentPage}
                                                                        setCurrentPage={this.updateItem}
                                                                        totalRecords={eventMasterList.length}
                                                                        pageLength={recordsPerPage}
                                                                        setPageLength={this.updateRecordsPerPage}
                                                                    />
                                                                ) : (
                                                                    <></>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                        </div>

                    </div >
                </section >
                {/* <Footer /> */}

            </>
        )
    }
}
export default withRouter(connect(null, { fill_action, get_eventMaster_list_action, delete_eventMaster_action })(eventMasterList));
